var map = {
	"./black/duofangguangbo2.png": "2EI3",
	"./blue/duofangguangbo2.png": "u0Te",
	"./white/duofangguangbo2.png": "ZT7/"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "jBVd";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom ^\.\/.*\/duofangguangbo2\.png$
// module id = jBVd
// module chunks = 24